<template>
<v-card class="ma-2" link outlined hover @mouseover="hover_card=true" @mouseleave="hover_card=false">
    <v-card-text>
        <v-row no-gutters dense>
            <v-col cols="3">
                <v-img height="200" aspect-ratio="16/9" :src="image">
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0 grey lighten-2" align="center" justify="center">
                            <v-progress-circular indeterminate color="white" />
                        </v-row>
                    </template>
                </v-img>
            </v-col>
            <v-col cols="7">
                <v-row dense no-gutters class="mx-2">
                    <v-col cols="12" class="display-1">
                        {{ item.hotel.name }}
                        <v-icon v-for="i in item.hotel.stars" small color="yellow darken-2" :key="i">star</v-icon>
                    </v-col>
                    <v-col cols="12" class="subtitle-1">
                        {{ item.hotel.static.location.address.city }}, {{ item.hotel.static.location.address.street }}
                    </v-col>
                    <v-col cols="12" class="caption">
                        {{ item.hotel.static.general.description.ro?item.hotel.static.general.description.ro:description }}
                    </v-col>
                    <v-col cols="12">
                        <v-chip class="px-2 mr-1" small v-for="(facility, key) of item.hotel.facilities" :key="key">
                            {{ item.hotel.static.facilities }}
                        </v-chip>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="2" class="">
                <div class="text-right subtitle-1">
                    Incepand de la
                </div>
                <div class="text-right headline">
                    {{ item.best_offer.price }} {{ item.best_offer.currency }}
                </div>
                <v-btn class="mt-2" block dark bottom :color="hover_card?'indigo':'primary'">Rezerva</v-btn>
            </v-col>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
import defaultImage from "@/assets/hotel.jpeg";

export default {
    name: "Hotel",

    props: {
        item: {
            type: Object,
        },
    },

    data: () => ({
        hover_card: false,
        image: defaultImage,
        description: 'Donec consequat ante nec metus tempor, id cursus nisi consequat. Curabitur vestibulum sollicitudin magna ut auctor. Quisque velit urna, sagittis sed massa in, porta ultricies massa. Nulla nec vestibulum sem, id venenatis orci. Praesent rutrum tortor sed ipsum iaculis consectetur. Nulla ultricies nisi justo, at vulputate augue accumsan sed. Praesent mollis nunc at rhoncus blandit. Pellentesque ut dui urna. Nunc nulla tellus, venenatis id diam vel, molestie congue tellus. Mauris et eleifend lectus. Sed gravida justo eu ex hendrerit, ut pretium dui elementum. Vestibulum ultricies arcu vitae gravida fringilla.'
    }),

    computed: {
        firstImage: function () {
            let [firstImage] = this.hotel.media;
            let {
                url
            } = firstImage;
            return url;
        },
        firstParagraph: function () {
            let {
                ro
            } = this.hotel.description;
            let [first] = ro.split("\r\n\r\n");
            return first;
        }
    },
}
</script>
